import React, { Component } from 'react';
import { Row, Col, Avatar, Tooltip } from 'antd';
// import InfiniteScroll from 'react-infinite-scroller';
import moment from 'moment';
// import service from '../../service/apolloclient.service';
import debounce from 'lodash.debounce';
import '../../css/Dashboard.scss';
// import '../../css/ActivityFeed.scss';
import Activity from './Activity';
import Sentence from './Sentence';

const userIcon = require('../../images/illustration-profile.png');

interface ActivityListProps {
    activities: any;
    pageSize: any;
    loadActivities: any;
    hasMore: any;
    filterObj: any;
    isCustomer: any;
}

interface ActivityListState {
    activities: any;
    error: boolean;
    hasMore: boolean;
    isLoading: boolean;
}

class ActivityList extends Component<ActivityListProps, ActivityListState> {
    constructor(props: any) {
        super(props);
        this.state = {
            activities: [],
            error: false,
            hasMore: true,
            isLoading: true
        };
    }

    componentDidMount() {
        // Detect scroll end to load more activities
        let listDiv: any = document.querySelector('#activityList');
        listDiv.onscroll = debounce(() => this.debounceCallback(listDiv), 200);
    }

    debounceCallback = (listDiv) => {
        const {
            state: {
                activities,
                error,
                isLoading,
                hasMore,
            },
        } = this;
        if (error || isLoading || !hasMore) {
            return;
        }
        // Checks that the page has scrolled to the bottom
        if (listDiv.offsetHeight + listDiv.scrollTop > listDiv.scrollHeight - 150) {
            if (activities.length === this.props.activities.length && this.props.hasMore) {
                this.setState({
                    isLoading: true
                });
                this.props.loadActivities();
            } else {
                this.loadActivities();
            }
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (this.props.activities !== nextProps.activities) {
            let activities;
            if (this.props.filterObj !== nextProps.filterObj) {
                console.log('filtered');
                activities = nextProps.activities.slice(0, this.props.pageSize);
            } else {
                // after loading new activities from server
                activities = nextProps.activities.slice(
                    0, this.state.activities.length + this.props.pageSize
                );
            }
            this.setState({
                activities,
                hasMore: (activities.length % this.props.pageSize) === 0,
                isLoading: false
            });
        }
    }

    getCustomer(activity: any) {
        if (!activity.customer) {
            return <b>Eye Guide</b>;
        } else {
            return <b>{activity.customer.name}</b>;
        }
    }

    formatDate(date: string) {
        if (date.indexOf('-') > -1) {
            let arr1 = date.split(' ');
            let arr2 = arr1[0].split('-');
            let arr3 = arr2.map((el, i) => {
                if (i === 0) {
                    return el;
                } else {
                    return ('0' + el).slice(-2);
                }
            });
            return arr3.join('-') + ' ' + arr1[1];
        }
        return date;
    }

    render() {
        return (
            <div id="activityList">
            {   
                this.state.activities.map((activity, i) => {
                    let info = new Activity(activity).getActivityInfo();
                    let sentence = new Sentence({
                        subject: <b>{activity.username}</b>,
                        preps: {
                            subject: !this.props.isCustomer ?
                                <span>from&nbsp;{this.getCustomer(activity)}</span>
                                : '',
                            object: info.preps ? info.preps : ''
                        },
                        verb: info.action,
                        object: info.object
                    });
                    let formatted = this.formatDate(activity.time);
                    let utc = moment(formatted).format('YYYY-MM-DD HH:mm:ss');
                    let stillUtc = moment.utc(utc).toDate();
                    let local = moment(stillUtc).format('YYYY-MM-DD HH:mm:ss');
                    return (
                        <Row key={i} style={{margin: 15}}>
                            <Col span={0.5} />
                            <Col span={19}>
                                <div style={{display: 'flex'}}>
                                    <Avatar 
                                        src={userIcon}
                                        style={{
                                            backgroundColor: '#8B9FB2',
                                            width: 32,
                                            height: 32 
                                        }} 
                                        icon="Image" 
                                        size="large"
                                        shape="circle"
                                    />
                                    &nbsp;&nbsp;&nbsp;{sentence.byTense(4)}
                                </div>
                            </Col>
                            <Col span={1} />
                            <Col span={3.5}>
                                <Tooltip title={local}>
                                    <span> {moment(local).fromNow()} </span>
                                </Tooltip>
                            </Col>
                        </Row>
                    );
                })
            }
            <div style={{textAlign: 'center', color: 'red'}}>
                {this.state.activities.length === 0 && !this.state.isLoading
                    && <span>No activities performed</span>}
                {this.state.isLoading && <span>Loading...</span>}
                {!this.state.hasMore && <span>You reached the end!</span>}
            </div>
            </div>
        );
    }

    /**
     * Load next activities from the state
     */
    loadActivities() {
        let listSize = this.state.activities.length;
        let activities = this.props.activities.slice(0, listSize + this.props.pageSize);
        this.setState({
            activities,
            hasMore: (activities.length % this.props.pageSize) === 0
        });
    } 
}

export default ActivityList;


// WEBPACK FOOTER //
// ./src/components/activityFeed/ActivityList.tsx